function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0 0h24v24H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M20.5 3.5c-4.7-4.7-12.3-4.7-17 0-4.7 4.7-4.7 12.3 0 17 4.7 4.7 12.3 4.7 17 0 4.7-4.7 4.7-12.3 0-17zM12 18.7a6.7 6.7 0 110-13.4 6.7 6.7 0 010 13.4zm3.3-16.8l-1.1 2c-.7-.2-1.5-.3-2.2-.3-.8 0-1.5.1-2.2.3l-1.1-2c2.2-.7 4.5-.7 6.6 0zM1.9 15.3c-.7-2.1-.7-4.4 0-6.6l2 1.1c-.2.7-.3 1.4-.3 2.2 0 .8.1 1.5.3 2.2l-2 1.1zm6.8 6.8l1.1-2c.7.2 1.4.3 2.2.3.8 0 1.5-.1 2.2-.3l1.1 2c-2.1.7-4.4.7-6.6 0zm11.5-7.9c.2-.7.3-1.5.3-2.2 0-.8-.1-1.5-.3-2.2l2-1.1c.7 2.1.7 4.4 0 6.6l-2-1.1z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M13.6 9.3c-.7 0-1.3.4-1.5 1-.3-.6-.9-1-1.5-1-.9 0-1.7.8-1.7 1.7 0 2.6 3.2 4 3.2 4s3.2-1.4 3.2-4c0-1-.7-1.7-1.7-1.7z"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2, _ref3);
};

export default SvgComponent;